import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';
import { Router } from '@angular/router';
import { ReservationContainerComponent } from '@app/_components/reservation/components/reservation/reservation-container/reservation-container.component';
import { ConstantService } from '@app/_services/constant.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ReservationListComponent } from '@app/_components/reservation/components/reservation-list/reservation-list.component';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import * as moment from 'moment';
@Component({
    selector: 'app-future-occupancy-dashboard',
    templateUrl: './future-occupancy-dashboard.component.html',
    styleUrls: ['./future-occupancy-dashboard.component.css'],
    standalone: false
})
export class FutureOccupancyDashboardComponent implements OnInit {

  @Input() showSearchUI = true;
	tempArray: any[]=[];
	totalSearchedDays: number = 0;

	// forms
	form1: UntypedFormGroup;
	futureOccupancyColumns: any;
	reportName = 'FUTURE_OCCUPANCY';
  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	constructor(
		public messageService: MessageService,
		public router: Router,
		public reportService: ReportService,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		private constantService: ConstantService) {
		//Load columns (Hidable) from service
		this.futureOccupancyColumns = this.reportService.futureOccupancyColumns;
	}


	// forms
	formLoading = false;

	// to hold the current search
	currentSearchForm: any;
	selectedDateRange: any = 0;
	searchedCheckInDate: Date;
	searchedCheckOutDate: Date;

	reservations: any[];
	resRevMasterByDay: any[];
	resRev: any [];
	saleVelocityAPI: any [];
	resRevByMonth: any [];
	resRevByYear: any [];
	resRevTotalByMonth: any [];
	reservationsTotalsByDay: any[];
	reservationsTotalsByMonth: any[];
	reservationsTotalsByYear: any[];
	futureOccupancyDynamicColumn: any[] = [];

	//Column array to display header on table and find propeties with field name
	columns: any[] = [
    	{ field: 'locationName', header: 'Location', width: 'auto' },
		{ field: 'developmentName', header: 'Development', width: 'auto' },
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
    	{ field: 'rate_bucket_name', header: 'Rate Bucket', width: 'auto' },
    	{ field: 'numNtsTTL', header: 'Nts', width: 'auto' },
		{ field: 'numNtsGuestTTL', header: 'GuestNts', width: 'auto' },
	];

  scrollableColumns: any[] = [
    	{ field: 'numNtsTTL', header: 'numNtsTTL', width: 'auto' },
		{ field: 'numNtsGuestTTL', header: 'numNtsGuestTTL', width: 'auto' },
    	{ field: 'unknownTTL', header: 'unknownTTL', width: 'auto' },
		{ field: 'revRoomRateNetTTL', header: 'revRoomRateNetTTL', width: 'auto' },
    	{ field: 'revRoomRateNetAVG', header: 'revRoomRateNetAVG', width: 'auto' },
    	{ field: 'Occupancy %', header: 'Occupancy %', width: 'auto' },
	];

	dateColumns: any[] = [];
	monthColumns: any[] = [];
	yearColumns: any[] = [];

	ngOnInit(): void {
		this.formBuild();
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			futureOccupancies: [],
		});
	}

	//Showing columns Dynamically based on dropdown selection
	selectedFutureOccupancies(event: any){
		console.log("event.value : "+JSON.stringify(event.value));
		this.futureOccupancyDynamicColumn = [];
		for (let i = 0; i < event.value.length; i++) {
		  this.futureOccupancyDynamicColumn.push(event.value[i].name);
		}
	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.generateDateColumns();
		this.runReservationRevenueReport(searchForm);
	}

	/**
	 * Create the column header dynamically based on selected date range for each day
	 */
	generateDateColumns() {
		this.dateColumns = [];
		this.monthColumns = [];
		this.yearColumns = [];

		var endDate = new Date(this.currentSearchForm.endDate);
		var startDate = new Date(this.currentSearchForm.startDate);
		startDate.setHours(0,0,0,0);

		var dayCount = 0;
		var prevMonth = null;
		var prevYear = null;
		//increment day one by one and add object to monthColumns array
		for(var dt=startDate; dt<=endDate; dt.setDate(dt.getDate()+1)){
			if(prevMonth == null) {
				prevMonth = dt.getMonth();
				prevYear = dt.getFullYear();
				this.monthColumns.push({ month: new Date (dt)});
				this.yearColumns.push({ year: new Date (dt)});
			} else {
				if(prevMonth != dt.getMonth()) {
					this.monthColumns.push({ month: new Date (dt)});
					prevMonth = dt.getMonth();
					if(prevYear != dt.getFullYear()) {
						this.yearColumns.push({ year: new Date (dt)});
						prevYear = dt.getFullYear();
					}
				}
			}
			this.totalSearchedDays = this.totalSearchedDays + 1;
		}
	}

	//Convert long amount to USD currency with two fractional digit
	currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return inrFormat.format(params);
	}


  /**
   * Get location name from contant service by location id
   */
  getLocationName (value: any) {
		if (value) {
			return this.constantService.locations.find(function(item) {
				return item.locationId == value
			})?.name;
		}
	};

	/**
	 * Set the specified date hours to 12:00 A.M
	 */
	setDateToMidNight(date: Date) {
		date.setHours(0,0,0,0);
	}

	/**
	 * Get the reservations for selected dates and filters
	 * @param searchForm
	 */
	runReservationRevenueReport(searchForm) {
		try {
			var startDate = this.addLocalTimeToDateTime(new Date(searchForm.startDate));
			var endDate = this.addLocalTimeToDateTime(new Date(searchForm.endDate));
			this.searchedCheckInDate = new Date(startDate);
			this.searchedCheckOutDate = new Date(endDate);
			searchForm.startDate = startDate;
			searchForm.endDate = endDate;
			this.formLoading = true;
			this.reservations = []; // First empty the reservation array when user click search
			this.setGroupByFields(searchForm);
			let reservationSeacrhRequest = Object.assign({}, searchForm); ; // Copy search form to reservationSeacrhRequest to separate request for reservation
			reservationSeacrhRequest.reservationStatusList = this.reportService.revanueReservations; // Fetch only active reservations
			reservationSeacrhRequest.reportName = this.reportName; // Send report name to get only related objects
			this.reportService.reservationRevenueReport(reservationSeacrhRequest)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));

						//Set map location id and set location name
                        res.data.resRevenues.resRev.forEach(response => {
							response.locationName = this.getLocationName(response.locationId);
							response.ownerAndOwnerGuestNts = response.numNtsOwnerTTL + response.numNtsOwnerGuestTTL;
							response.totalOccupancy = response.numNtsTTL / this.totalSearchedDays;
							response.guestOccupancy = response.numNtsGuestTTL / this.totalSearchedDays;
							response.nonGuestOccupancy = ((response.numNtsOwnerTTL + response.numNtsOwnerGuestTTL + response.numNtsMaintTTL) / this.totalSearchedDays);
							
                        });
						this.resRev = res.data.resRevenues.resRev;
						this.saleVelocityAPI = res.data.resRevenues.saleVelocityAPI;

						//Get reservation by months
						var groupByList = ['shortTermRentalId', 'year', 'month'];
						var orderByList = ['shortTermRentalId', 'year', 'month'];
						searchForm.groupByList = groupByList;
						searchForm.orderByList = orderByList; // order by shortTermRentalId, year and month as we are fetching for all the dates
						searchForm.fetchAllDatesInRange = true; // Fetch dates/months even if no reservation
						searchForm.reportName = this.reportName; // Send report name to get only related objects
						searchForm.reservationStatusList = this.reportService.revanueReservations; // Fetch only active reservations
						this.reportService.reservationRevenueReport(searchForm)
							.subscribe(
								res => {
									console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));
									res.data.resRevenues.resRev.forEach(response => {
										response.locationName = this.getLocationName(response.locationId);
									});
									this.resRevByMonth = res.data.resRevenues.resRev;
									this.resRevByYear = res.data.resRevenues.resRevByYear;
									this.resRevTotalByMonth = res.data.resRevenues.resRevByMonth;
									this.mergesaleVelocity();
									this.mergeMonthByReservations();
									this.mergeYearByReservations();
								},
								err => {
									console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
									this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
								},
								() => {
									this.formLoading = false;
								});
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => {
						//  this.formLoading = false;
					});

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	/*********
		* Open Reservation list
		*
		*/
		showReservationList(reservation: any) {
			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.maxWidth = "100vw";
			dialogConfig.width = "80vw";
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				reservation: reservation,
				title: 'Reservations'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(ReservationListComponent, dialogConfig);
		}

	/**
	 * Show background color based on occupancy percentage
	 * @param pctNtsOcc
	 * @returns
	 */
	getBGColor(pctNtsOcc) {
		if(pctNtsOcc > 0.9) {
			return '#12a15e50';
		} else if (pctNtsOcc > 0.8 && pctNtsOcc < 0.9) {
			return '#a3f5cf50';
		} else if (pctNtsOcc > 0.7 && pctNtsOcc < 0.8) {
			return '#e6d51950';
		} else if (pctNtsOcc > 0.6 && pctNtsOcc < 0.7) {
			return '#f58c8c50';
		} else if (pctNtsOcc > 0.5 && pctNtsOcc < 0.6) {
			return '#f74d4d50';
		} else {
			return '#f21b1b50';
		}
	}

	setGroupByFields(searchForm) {
		var groupByList = ['shortTermRentalId'];
		searchForm.groupByList = groupByList;
	}

	mergesaleVelocity() {
		if (this.resRev) {
			// this.resRev.forEach((reservation) => {
			// 	this.saleVelocityAPI.forEach((saleVelocity) => {
			// 		if (saleVelocity.shortTermRentalId != null && reservation.shortTermRentalId == saleVelocity.shortTermRentalId) {
			// 			if (reservation.saleVelocityAPI) {
			// 				reservation.saleVelocityAPI.push(saleVelocity);
			// 			} else {
			// 				reservation.saleVelocityAPI = [];
			// 				reservation.saleVelocityAPI.push(saleVelocity);
			// 			}
			// 		}
			// 	});
			// });
			const saleVelocityMap = new Map();
			this.saleVelocityAPI.forEach(saleVelocity => {
				if(saleVelocity.shortTermRentalId)
				{
					saleVelocityMap.set(saleVelocity.shortTermRentalId, saleVelocity);
				}
			});

			this.resRev.forEach(reservation => {
				if (saleVelocityMap.has(reservation.shortTermRentalId)) {
					reservation.saleVelocityAPI = [saleVelocityMap.get(reservation.shortTermRentalId)];
				}
			});
			console.log('saleVelocityAPI');
			console.log(this.saleVelocityAPI);
		}
	}

	mergeMonthByReservations() {
		if (this.resRev) {
			// this.resRev.forEach((reservation) => {
			// 	this.resRevByMonth.forEach((reservationByMonth) => {
			// 		if (reservation.shortTermRentalId == reservationByMonth.shortTermRentalId) {
			// 			if (reservation.reservationsByMonth) {
			// 				reservation.reservationsByMonth.push(reservationByMonth);
			// 			} else {
			// 				reservation.reservationsByMonth = [];
			// 				reservation.reservationsByMonth.push(reservationByMonth);
			// 			}
			// 		}
			// 	});
			// });
			 
			 // Create a map to store an array of reservations by shortTermRentalId
			 const reservationByMonthMap = new Map<string, any[]>();

			 // Populate the map with the data from resRevByMonth, storing an array of items for each shortTermRentalId
			 this.resRevByMonth.forEach((reservationByMonth) => {
			   if (!reservationByMonthMap.has(reservationByMonth.shortTermRentalId)) {
				 reservationByMonthMap.set(reservationByMonth.shortTermRentalId, []);
			   }
			   reservationByMonthMap.get(reservationByMonth.shortTermRentalId).push(reservationByMonth);
			 });
		 
			 // Now merge the data into resRev using the map for fast lookups
			 this.resRev.forEach((reservation) => {
			   const reservationsForMonth = reservationByMonthMap.get(reservation.shortTermRentalId);
			   if (reservationsForMonth) {
				 // If reservationsByMonth doesn't exist, create it and assign the array
				 reservation.reservationsByMonth = reservationsForMonth;
			   }
			 });
			console.log('Reservations');
			console.log(this.resRev);
		}
	}

	mergeYearByReservations() {
		if (this.resRev) {
			// this.resRev.forEach((reservation) => {
			// 	this.resRevByYear.forEach((reservationByYear) => {
			// 		if (reservation.shortTermRentalId == reservationByYear.shortTermRentalId) {
			// 			if (reservation.reservationByYear) {
			// 				reservation.reservationByYear.push(reservationByYear);
			// 			} else {
			// 				reservation.reservationByYear = [];
			// 				reservation.reservationByYear.push(reservationByYear);
			// 			}
			// 		}
			// 	});
			// });

			const reservationByYearMap = new Map<string, any[]>();

			// Populate the map with the data from resRevByYear, storing an array of items for each shortTermRentalId
			this.resRevByYear.forEach((reservationByYear) => {
				if (!reservationByYearMap.has(reservationByYear.shortTermRentalId)) {
					reservationByYearMap.set(reservationByYear.shortTermRentalId, []);
				}
				reservationByYearMap.get(reservationByYear.shortTermRentalId).push(reservationByYear);
			});

			// Now merge the data into resRev using the map for fast lookups
			this.resRev.forEach((reservation) => {
				const reservationsForYear = reservationByYearMap.get(reservation.shortTermRentalId);
				if (reservationsForYear) {
					// If reservationByYear doesn't exist, create it and assign the array
					reservation.reservationByYear = reservationsForYear;
				}
			});
			console.log('Reservations');
			console.log(this.resRev);
		}
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}
  exportSelected($event: any) {
    let copiedData =  this.resRev;
    let modifiedData = [];
    copiedData.forEach(data => {
      let entry = {
        month: undefined,
        holdExpiredDate: undefined
      };
      entry.month = data.month;
      entry.holdExpiredDate = moment.utc(data.holdExpiredDate).format('MM/DD/YYYY');
      modifiedData.push(entry);
    });
    this.importExportComponent.exporData($event, modifiedData, 'Future Occupancy List');
  }
}
